import light from "rich-markdown-editor/dist/theme"

export const theme = {
  ...light,
  fontFamily:
    'Noto Sans SC", "Helvetica Neue", "Helvetica", Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif',
};

export const dictionary = {
  addColumnAfter: "后面插入列",
  addColumnBefore: "前面插入列",
  addRowAfter: "后面插入行",
  addRowBefore: "前面插入行",
  alignCenter: "居中",
  alignLeft: "居左",
  alignRight: "居右",
  bulletList: "符号列表",
  checkboxList: "待办列表",
  codeBlock: "代码块",
  codeCopied: "已复制",
  codeInline: "代码",
  createLink: "创建链接",
  createLinkError: "抱歉，创建链接出现错误",
  createNewDoc: "创建新的文档",
  deleteColumn: "删除列",
  deleteRow: "删除行",
  deleteTable: "删除表格",
  em: "斜体",
  embedInvalidLink: "抱歉目标链接无法适配嵌入类型，获取详细说明请点击右下角帮助",
  findOrCreateDoc: "查找或者创建文档…",
  h1: "大标题",
  h2: "中标题",
  h3: "小标题",
  heading: "标题",
  hr: "分割线",
  image: "图片",
  imageUploadError: "抱歉，上传图片出现错误",
  info: "信息",
  infoNotice: "信息通知",
  link: "链接",
  linkCopied: "链接已复制",
  mark: "高亮",
  newLineEmpty: "输入 '/' 插入…",
  newLineWithSlash: "继续输入来过滤…",
  noResults: "无结果",
  openLink: "打开链接",
  orderedList: "顺序列表",
  pasteLink: "粘贴链接…",
  pasteLinkWithTitle: (title: string) => `粘贴一个 “${title}” 链接`,
  placeholder: "占用符",
  quote: "引用",
  removeLink: "移除链接",
  searchOrPasteLink: "搜索或粘贴链接…",
  strikethrough: "删除线",
  strong: "加粗",
  subheading: "子标题",
  table: "表格",
  tip: "提示",
  tipNotice: "提示通知",
  warning: "警告",
  warningNotice: "警告通知",
};
